import { ApiService } from '../ApiService';
import { plainToClass } from '~/models/transform';
import { WeightListView, WeightChartData } from '~/models/Weight';

export interface IWeightListParams {
  memberId?: number;
  skip?: number;
  take?: number;
  sortBy?: 'date' | 'weight';
  sortDir?: 'asc' | 'desc';
}

export interface IWeightChartParams {
  memberId?: number;
  buckets?: number;
}

export interface IWeightRecordPayload {
  DateWeighted: string;
  WeightKg: number;
  Notes?: string;
}

export class WeightsService {
  /**
   * Fetch paginated weight records.
   * @param params Query params: memberId, skip, take, sortBy, sortDir
   */
  static async getWeights(params?: IWeightListParams): Promise<WeightListView> {
    const response = await ApiService.get<WeightListView>('weights', params);
    return plainToClass(WeightListView, response);
  }

  /**
   * Fetch weight chart data with time-based buckets.
   * @param params Query params: memberId, buckets
   */
  static async getChart(params?: IWeightChartParams): Promise<WeightChartData> {
    const response = await ApiService.get<WeightChartData>('weights/chart', params);
    return plainToClass(WeightChartData, response);
  }

  /**
   * Create or upsert a weight record for the current user.
   * @param data Weight record payload
   */
  static async createWeight(data: IWeightRecordPayload): Promise<void> {
    await ApiService.post('weights', data);
  }

  /**
   * Update an existing weight record by ID.
   * @param id Weight record ID
   * @param data Updated weight record payload
   */
  static async updateWeight(id: number, data: IWeightRecordPayload): Promise<void> {
    await ApiService.put(`weights/${id}`, data);
  }

  /**
   * Delete a weight record by ID.
   * @param id Weight record ID
   */
  static async deleteWeight(id: number): Promise<void> {
    await ApiService.delete(`weights/${id}`);
  }
}
